// Custom dayjs locale for Welsh (Cymraeg)
export const cy = {
    name: 'cy',
    weekdays: [
        'Dydd Sul',
        'Dydd Llun',
        'Dydd Mawrth',
        'Dydd Mercher',
        'Dydd Iau',
        'Dydd Gwener',
        'Dydd Sadwrn',
    ],
    weekdaysShort: ['Sul', 'Llun', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
    weekdaysMin: ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
    months: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr',
    ],
    monthsShort: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag',
    ],
    weekStart: 1, // Monday
    yearStart: 4,
    formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMM YYYY',
        LLL: 'D MMM YYYY HH:mm',
        LLLL: 'dddd, D MMM YYYY HH:mm',
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd',
    },
    ordinal: (n: number) => n + (n === 1 ? 'af' : n === 2 ? 'ail' : n === 3 ? 'ydd' : 'ed'),
};
